import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-165">
      {children}
    </motion.div>;
}
export function Button({
  children,
  onClick,
  className = '',
  fullWidth = false
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`
        relative group overflow-hidden rounded-none bg-toxic text-black font-display font-bold uppercase tracking-wider
        px-8 py-4 transition-all duration-300
        hover:shadow-toxic-glow-lg hover:bg-white
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-166">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-167">
        {children}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-168" />
    </motion.button>;
}